import request from '@/http'

export function authorizedUrlGitHub () {
  return request({
    url: '/thirdPartyLogin/authorizedUrlGitHub',
    method: 'post'
  })
}

export function callbackGitHub (data) {
  return request({
    url: '/thirdPartyLogin/callbackGitHub',
    method: 'post',
    data
  })
}

export function callbackWeinxin (data) {
  return request({
    url: '/thirdPartyLogin/callback',
    method: 'post',
    data
  })
}


export function authorizedUrlWeixin () {
  return request({
    url: '/thirdPartyLogin/authorizedUrl',
    method: 'post'
  })
}

export function getTenantInfo (systemcode) {
  return request({
    url: '/user/getTenantInfo',
    method: 'post',
    data: { systemcode }
  })
}

export function toRelateThirdParty (phone, openid, thirdtype) {
  return request({
    url: '/user/thirdAndUser',
    method: 'post',
    data: { phone, openid, thirdtype }
  })
}

export function getConfigByCode (code) {
  return request({
    url: '/user/getConfigByCode',
    method: 'post',
    data: { code: code }
  })
}

export function callbackDesktopAuth (token) {
  return request({
    url: '/thirdPartyLogin/desktopLogin',
    method: 'post',
    data: { token }
  })
}
// 获取ck
export function getUserAkInfo (data) {
  return request({
    url: '/user/getAkInfo',
    method: 'post',
    data
  })
}
// 获取图层资源
export function getResourceInfo (data) {
  return request({
    url: '/user/getResourceInfo',
    method: 'post',
    data
  })
}
// 获取权限
export function fetchPermissionList(data) {
  return request({
    url: '/user/listPermission',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/sys/auth.js